import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { DocumentTypes } from '@debbie/common/dist/documents/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import { Button, ButtonGroup, Checkbox } from '../..//index.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
const DocumentsGroup = (props) => {
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(FilterGroup, { name: lang.caseFilter.documentsGroup },
        React.createElement(FilterOption, { active: !!(caseFilter.documentTypes && caseFilter.documentTypes.length), header: lang.caseFilter.hasDocumentOfType, onDeactivate: () => c.insights.clearFilter('documentTypes') },
            React.createElement(Select, { value: (caseFilter.documentTypes || []).map((documentType) => ({
                    label: lang.documentTypes[documentType],
                    value: documentType,
                })), isMulti: true, placeholder: lang.caseFilter.selectDocumentTypes, classNamePrefix: "select", options: Object.entries(DocumentTypes).map((entry) => ({
                    label: lang.documentTypes[entry[1]],
                    value: entry[1],
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        documentTypes: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.documentTypesIsSigned === 'boolean', header: lang.caseFilter.documentsIsSigned, onDeactivate: () => c.insights.clearFilter('documentTypesIsSigned') },
            React.createElement(Checkbox, { style: { marginBottom: '0' }, checked: caseFilter.documentTypesIsSigned, onChange: (e) => {
                    if (e.target.checked) {
                        c.insights.updateFilter({
                            documentTypesIsSigned: true,
                        });
                        return;
                    }
                    c.insights.clearFilter('documentTypesIsSigned');
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.hasFoundation === 'boolean', header: lang.caseFilter.hasFoundation, onDeactivate: () => c.insights.clearFilter('hasFoundation') },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { size: "mini", theme: caseFilter.hasFoundation ? undefined : 'secondary', onClick: () => {
                        c.insights.updateFilter({
                            hasFoundation: caseFilter.hasFoundation ? undefined : true,
                        });
                    } }, lang.caseFilter.hasFoundation),
                React.createElement(Button, { size: "mini", theme: caseFilter.hasFoundation === false ? undefined : 'secondary', onClick: () => {
                        c.insights.updateFilter({
                            hasFoundation: caseFilter.hasFoundation === false ? undefined : false,
                        });
                    } }, lang.caseFilter.hasNoFoundation)))));
};
export default DocumentsGroup;
//# sourceMappingURL=DocumentsGroup.js.map